module.exports = __webpack_public_path__ + "static/media/cheveuxnappy-featuresplit-1.84317dff.jpg";